import {
  FETCH_PARTY_REQUEST,
  FETCH_PARTY_SUCCESS,
  FETCH_PARTY_FAILURE,
} from "./RelatedPartyActionTypes";

const initialState = {
  loading: false,
  relatedPartyData: {},
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PARTY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PARTY_SUCCESS:
      return {
        loading: false,
        relatedPartyData: action.payload,
        error: "",
      };
    case FETCH_PARTY_FAILURE:
      return {
        loading: false,
        relatedPartyData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
